export function niceStep(raw){
  const base = Math.pow(10, Math.floor(Math.log10(Math.max(raw, 1e-9))));
  const frac = raw / base;
  const nice = frac <= 1 ? 1 : frac <= 2 ? 2 : frac <= 2.5 ? 2.5 : frac <= 4 ? 4 : frac <= 5 ? 5 : 10;
  return nice * base;
}
